<template>
  <div class="container">
    <div class="video" v-if="data.link!=null&&data.link.length>0&&data.link[0]!=''" style="oveflow:hidden;">
      <!--<iframe :src="data.link"-->
              <!--allow='autoplay;encrypted-media' allowfullscreen >-->
      <!--</iframe>-->
      <video v-for="(item,index) in data.link" :src="item" :key="index" controls="controls"></video>
    </div>
    <iframe ref="myIframe" id="myIframe" scrolling="no" frameborder="0" style="width: 100%; height: 100%;" src="/html/linianwenhua.html"></iframe>

  </div>
</template>

<script>
  import {getEnterpriseList} from "../../../api/zoujindaweijia"
  export default {
    name: "Qi",
    data(){
      return{
        data:[]
      }
    },
    methods:{
      sendMessageToIframe: function(data){
          const iframe = this.$refs.myIframe;
          // 使用 postMessage 发送数据给 iframe
          iframe.contentWindow.postMessage(data, "*");
      },
    },
    mounted() {
      getEnterpriseList().then(res=>{
        // console.log(res.data[1]);
        let data = res.data[0];
        var arr  = data.link.split('\r\n')
        console.log("arr")
        console.log(arr)
        data.link = arr;
        this.data = data;
        
      this.sendMessageToIframe(data)
      })

    }
  }
</script>

<style scoped>
  .container{
    width: 62.4479vw;
    /* height: 34.6875vw; */
    /*border: 0.0521vw solid #c0000d;*/
    margin-left: 17.7776vw;
    margin-bottom: 10.4151vw;
  }
  video{
    width: 62.4479vw;
    height: 34.6875vw;
  }
</style>